import React from 'react';
import './About.css'

const About = () => {
    return (
        <div className="row">
            <div className="col-md-6  about">
               <img src="https://imgdb.net/storage/uploads/7977221afaf72d65d42c10e39911cf7730ba20a7e5969739e6fbe2866c700eca.jpg" alt=""></img>
            </div>
            <div className="col-md-6">
               <h2>About Us</h2>
               <p>The Travelpoka will give you a lifetime memorable experience inbound & outbound of country. We are committed to offer you the highest quality of travel service with our years of experience</p>
            </div>
            
        </div>
    );
};

export default About;